import { useContext, useState } from 'react'
import { AppContext } from '../../../contextApi/ContextApi';
import { ClientContext } from '../../../contextApi/ClientContext';

export default function UpdateInfoBeforePayment({website, setNeedUpdate, needUpdate, isMissingAddress, setIsMissingAddress, setIsMissingPaymentMethod, isMissingPaymentMethod, setProblem, _finalPrice}) {
    const { accent_color, primary_color, currentUser, setCurrentUser, setCurrentWebsite, setToastMessage, messagesOptions, getTodayDate } = useContext(AppContext);
    const { handleClientPayment, isPaying} = useContext(ClientContext);
    const [addressInput, setAddressInput] = useState("");
    const [cardNumInput, setCardNumInput] = useState("");
    const [expDateInput, setExpDateInput] = useState("");
    const [cvvInput, setCvvInput] = useState("");
    const [isHoveringPayBtn, setIsHoveringPayBtn] = useState(false);
    
    const handleUpdate = async()=>{
        try {
            const res = await handleClientPayment(needUpdate, getTodayDate, website, currentUser, setCurrentUser, setCurrentWebsite, setProblem, setToastMessage, messagesOptions, isMissingPaymentMethod, isMissingAddress, _finalPrice, addressInput, cardNumInput, expDateInput, cvvInput)
            if(res){
                setIsMissingAddress(false);
                setIsMissingPaymentMethod(false);
                setNeedUpdate(false);
            }
        } catch (error) {
            console.error("Error on update at payment method: ",error)
        }
    }
    const handleChangeNum = (val) => {
        let raw = val.replace(/\s/g, "");
        if (raw.length > 16) raw = raw.slice(0, 16);
        const formatted = raw.match(/.{1,4}/g)?.join(" ") || "";
        setCardNumInput(formatted);
    };
    const handleChangeCVV = (val) => {
        let raw = val.replace(/\s/g, "");
        if (raw.length > 3) raw = raw.slice(0, 3);
        setCvvInput(raw);
    };
  return (
    <div className='updateInfoBeforePayment_container' dir='rtl'>
        <h1 style={{color:accent_color, textShadow:`2px 2px 4px ${primary_color}`}}>עדכון פרטים למשלוח</h1>
        <div className='updateInfoBeforePayment_mainDiv'>
            {isMissingAddress&&<div className='updateInfoBeforePayment_address'>
                <label htmlFor="payment_addressInput">כתובת:</label>
                <input id='payment_addressInput' type='text' placeholder='הנביאים 3 תל אביב' onChange={(e)=>{setAddressInput(e.target.value)}}/>
            </div>}
            {isMissingPaymentMethod&&<div className='updateInfoBeforePayment_paymentMethod'>
                <div className='updateInfoBeforePayment_paymentMethod_subDiv'>
                    <label htmlFor="payment_cardNumInput">מס' כרטיס אשראי:</label>
                    <input dir='ltr' id='payment_cardNumInput' type='text' placeholder='1234 1234 1234 1234' onChange={(e)=>{handleChangeNum(e.target.value)}} value={cardNumInput}/>
                </div>
                <div className='updateInfoBeforePayment_paymentMethod_subDiv'>
                    <label htmlFor="payment_expDateInput">תוקף כרטיס האשראי:</label>
                    <input id='payment_expDateInput' type='date' onChange={(e)=>{setExpDateInput(e.target.value)}} min={getTodayDate()}/>
                </div>
                <div className='updateInfoBeforePayment_paymentMethod_subDiv'>
                    <label htmlFor="payment_cvvInput">CVV:</label>
                    <input id='payment_cvvInput' type='text' placeholder='123' onChange={(e)=>{handleChangeCVV(e.target.value)}} value={cvvInput}/>
                </div>
            </div>}
        </div>
        <button className='updateInfoBeforePayment_payBtn' style={{color: isHoveringPayBtn ? primary_color : accent_color, backgroundColor:isHoveringPayBtn ? accent_color : primary_color, boxShadow:!isHoveringPayBtn ? null : `2px 2px 4px ${primary_color}`}} onMouseEnter={()=>{setIsHoveringPayBtn(true)}} onMouseLeave={()=>{setIsHoveringPayBtn(false)}} disabled={isPaying} onClick={handleUpdate}>{isPaying ? "המתן..." : "שמור ובצע תשלום"}</button>
    </div>
  )
}
